import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { supportUrl } from 'Config/lang';
import Alert from 'Components/Utility/Alert';

export default function ProductStatusMessage({ statusMessage, type, baseGame }) {
  if (isEmpty(statusMessage)) return false;

  return (
    <div className="p2">
      {statusMessage.indexOf('early-access') > -1 &&
        <Alert status="info">
          <p className="mb-0">
            <strong><FormattedMessage id="desktop.product.earlyaccess.title" defaultMessage="Early Access." /></strong>
            <FormattedMessage
              id="desktop.product.earlyaccess.description"
              defaultMessage=" This {productType} is currently not finished and may or may not change significantly over the course of its development."
              values={{
                productType: type,
              }}
            />
            <a href="http://store.steampowered.com/earlyaccessfaq/"><FormattedMessage id="desktop.product.earlyaccess.findoutlink" defaultMessage=" Find out more" /></a>
          </p>
        </Alert>
      }

      {statusMessage.indexOf('dlc') > -1 &&
        <div className={`d-flex flex-nowrap align-items-center product-dlc mb-4 ${statusMessage.indexOf('epic-games') > -1 ? 'p-2' : ''}`}>
          <div className="p-2 w-100 order-2">
            <strong><FormattedMessage id="desktop.product.dlc.title" defaultMessage="Downloadable Content." /></strong>&nbsp;
            {!isEmpty(baseGame) ?
              <FormattedMessage
                id="desktop.product.dlc.description.parent"
                defaultMessage="This content requires {parent} on the same platform in order to play"
                values={{
                  parent: <Link to={`/${baseGame.type}/${baseGame.slug}`}>{baseGame.name}</Link>,
                }}
              />
              :
              <React.Fragment>
                <FormattedMessage id="desktop.product.dlc.description" defaultMessage="This content requires the base game on the same platform in order to play" />
              </React.Fragment>
            }
          </div>
        </div>
      }

      {statusMessage.indexOf('ubisoft') > -1 &&
        <Alert status="info">
          <p className="mb-0">
            <strong><FormattedMessage id="desktop.product.ubisoftska.title" defaultMessage="This title is redeemed via Ubisoft Connect." /></strong>&#8200;
            <FormattedMessage id="desktop.product.ubisoftska.description" defaultMessage="Please note that you will NOT receive a Ubisoft Connect key." /> &#8200;
            <strong>
              <a href={`${supportUrl()}/articles/360000066997`} target="_blank" rel="noopener noreferrer">
                <FormattedMessage id="desktop.product.earlyaccess.findoutlink2" defaultMessage="Find out more" />
              </a>
            </strong>
          </p>
        </Alert>
      }

      {statusMessage === 'bethesda' && status.indexOf('dlc') > -1 &&
        <Alert status="info">
          <p className="mb-0">
            <strong><FormattedMessage id="desktop.product.bethesda.title" defaultMessage="This title is delivered as a Bethesda DRM Key and will require activation on Bethesda.net." /></strong> &#8200;
            <strong>
              <a href={`${supportUrl()}/articles/360001626178`} target="_blank" rel="noopener noreferrer">
                <FormattedMessage id="desktop.product.bethesda.link.find-out-more" defaultMessage="Find out more" />
              </a>
            </strong>
          </p>
        </Alert>
      }

      {statusMessage.indexOf('origin') > -1 &&
        <Alert status="info">
          <p className="mb-0">
            <strong><FormattedMessage id="desktop.product.originska.title" defaultMessage="This title is redeemed via EA Origin." /></strong>&nbsp;
            <FormattedMessage id="desktop.product.originska.description" defaultMessage="Please note that you will NOT receive an Origin key." /> &#8200;
            <a href={`${supportUrl()}/articles/360003854337`} target="_blank" rel="noopener noreferrer">
              <FormattedMessage id="desktop.product.earlyaccess.findoutlink3" defaultMessage="Find out more" />
            </a>
          </p>
        </Alert>
      }

      {/* Epic Keyless */}
      {statusMessage.indexOf('epic-keyless') > -1 &&
        <Alert status="info">
          <p className="mb-0">
            <strong><FormattedMessage id="desktop.product.epicska.title" defaultMessage="This title is delivered as Epic DRM." /></strong>&nbsp;
            <FormattedMessage id="desktop.product.epicska.description" defaultMessage="This title is redeemed via Epic connection and you will NOT receive a key." /> &#8200;
          </p>
        </Alert>
      }

      {/* Epic Key */}
      {statusMessage.indexOf('epic-keys') > -1 &&
        <Alert status="info">
          <p className="mb-0">
            <strong><FormattedMessage id="desktop.product.noepicska.title" defaultMessage="This title is delivered as Epic DRM." /></strong>&nbsp;
            <FormattedMessage id="desktop.product.noepicska.description" defaultMessage="Your key will require activation on the Epic launcher." /> &#8200;
            <a href={`${supportUrl()}/articles/360001750957`} target="_blank" rel="noopener noreferrer">
              <FormattedMessage id="desktop.product.earlyaccess.findoutlink3" defaultMessage="Find out more" />
            </a>
          </p>
        </Alert>
      }

      {/* VR Update */}
      {statusMessage.indexOf('vr-update') > -1 &&
        <div className="carousel-status-message">
          <span className="message-title">
            <FormattedMessage
              id="product-status-messages.vr-update.title"
              defaultMessage="Free VR DLC Available."
            />
          </span>&nbsp;
          <FormattedMessage
            id="product-status-messages.vr-update.description"
            defaultMessage="A free update can be downloaded post-purchase to add VR support to this title."
          />&nbsp;
          <a href="https://store.steampowered.com/app/474720/Catlateral_Damage_VR/" target="_blank" rel="noopener noreferrer">
            <FormattedMessage
              id="product-status-messages.vr-update.findoutlink"
              defaultMessage="Find out more"
            />
          </a>
        </div>
      }
    </div>
  );
}

ProductStatusMessage.propTypes = {
  statusMessage: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.string,
  baseGame: PropTypes.shape({}),
};

ProductStatusMessage.defaultProps = {
  statusMessage: [],
  type: '',
  baseGame: null,
};
